import { Image, ImageProps } from './Image';

type ParentProps = Omit<
  ImageProps,
  'width' | 'height' | 'layout' | 'objectFit'
>;

interface Props extends ParentProps {}

export const AutoFullImage = ({ src, ...others }: Props) => {
  return (
    <div className="auto-adjust-img">
      <Image
        src={src}
        layout="fill"
        objectFit="contain"
        {...others}
      />
    </div>
  );
};
